import cookieUtils from 'cookie-utils';
import hfConfig from 'hfConfig';

let PcLinkModule = {};

PcLinkModule.getPrivateMethods = () => PcLinkModule;

/**
 * https://frontbackend.com/javascript/what-is-the-difference-between-location-replace-and-location-href
 * https://www.samanthaming.com/tidbits/86-window-location-cheatsheet/
**/
PcLinkModule.linkHandler = (pcSiteUrl) => window.location.assign(pcSiteUrl);

PcLinkModule.clickHandler = (event) => {
  event.preventDefault();
  PcLinkModule.cookieEdits();

  let pcSiteUrl = '';
  const absoluteUrlPattern = /^https?:\/\//i;

  let thisHref = '';
  if (typeof (event?.target?.href) !== 'undefined') thisHref = event?.target?.href;

  if (typeof (hfConfig.deepLinkUrl) === 'undefined') pcSiteUrl = thisHref;
  else if (!absoluteUrlPattern.test(hfConfig.deepLinkUrl)) pcSiteUrl = `${thisHref}${hfConfig.deepLinkUrl}`;
  else pcSiteUrl = hfConfig.deepLinkUrl;

  PcLinkModule.linkHandler(pcSiteUrl);
};

PcLinkModule.cookieEdits = () => {
  if (hfConfig.currentChannel === 'web' && cookieUtils.hasBrowserCookie('THD_USR_AGENT_OVERRIDE')) {
    cookieUtils.deleteBrowserCookie('THD_USR_AGENT_OVERRIDE', THD_GLOBAL.cookieDomain);

  } else if (hfConfig.currentChannel === 'mobile') {
    cookieUtils.setCookieExpireInSeconds('THD_USR_AGENT_OVERRIDE', 'FULL', 18000, THD_GLOBAL.cookieDomain);
    cookieUtils.deleteBrowserCookie('THD_ONLINE_CHANNEL', THD_GLOBAL.cookieDomain);
    cookieUtils.deleteBrowserCookie('MOBILE_WEB', THD_GLOBAL.cookieDomain);
  }
};

PcLinkModule.init = () => document.getElementById('linkPcSite')?.addEventListener('click', PcLinkModule.clickHandler);

export default PcLinkModule;
